var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomZone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,2.5c-7.2,0-13,5.8-13,13s5.8,13,13,13,13-5.8,13-13S22.7,2.5,15.5,2.5M15.5,31C7,31,0,24,0,15.5S7,0,15.5,0s15.5,7,15.5,15.5-7,15.5-15.5,15.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,14.4v-4.2c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1v4.2h-4.2c-.6,0-1.1.5-1.1,1.1s.5,1.1,1.1,1.1h4.2v4.2c0,.6.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-4.2h4.2c.6,0,1.1-.5,1.1-1.1s-.5-1.1-1.1-1.1c0,0-4.2,0-4.2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomZone);
export default __webpack_public_path__ + "static/media/zoom-zone.ebaccf5bbf2b1e1f3326bf6b5b000e42.svg";
export { ForwardRef as ReactComponent };